import type { IFilter } from 'src/components/price-list/types';
import { FilterType } from 'src/components/price-list/types';
import type { AlternativePrice, Price } from 'src/types';

export const getApplicableFilters = (
  filters: IFilter[],
  offers: Price[],
  allOffersWithActiveAdditives: Price[]
): IFilter[] => {
  const hasAuthorizedInOffers = getHasAuthorizedInOffers(
    allOffersWithActiveAdditives
  );
  const hasInternationalOffers = getHasInternationalOffers(offers);
  const hasNotAvailableOffers = getHasNotAvailableOffers(offers);
  const updatedFilters = filters.filter(
    filter =>
      (filter.type !== FilterType.AUTHORIZED_DEALER || hasAuthorizedInOffers) &&
      (filter.type !== FilterType.INTERNATIONAL || hasInternationalOffers) &&
      (filter.type !== FilterType.NOT_FOR_SALE || hasNotAvailableOffers)
  );
  return updatedFilters;
};

const getHasAuthorizedInOffers = (offers: Price[]): boolean =>
  offers.some(offer => offer.authorizedDealer);

const getHasInternationalOffers = (offers: Price[]): boolean => {
  return offers.some(
    offer => !offer.primaryMarket || getHasInternationalAlternatives(offer)
  );
};

const getHasInternationalAlternatives = (offer: Price): boolean => {
  const alternativeOffers = (offer.alternativePrices ??
    []) as AlternativePrice[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(altOffer => !altOffer.primaryMarket);
};

const getHasNotAvailableOffers = (offers: Price[]): boolean => {
  return offers.some(
    offer =>
      offer.availability?.condition === 'NotAvailableForOrder' ||
      getHasNotAvailableAlternatives(offer)
  );
};

const getHasNotAvailableAlternatives = (offer: Price): boolean => {
  const alternativeOffers = (offer.alternativePrices ??
    []) as AlternativePrice[];
  if (alternativeOffers.length === 0) {
    return false;
  }
  return alternativeOffers.some(
    altOffer => altOffer.availability?.condition === 'NotAvailableForOrder'
  );
};
